var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2235_167920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8021 0.25H0.558685V17.7502H13.8021V13.4378L12.3831 14.8567V9.18097L13.8021 7.76205V0.25Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2235_167920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0184 2.61523L13.3293 5.92608H10.0184V2.61523Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10686 3.36523H9.36192V1.86523H3.10686V3.36523ZM3.20061 15.6753V3.27148H1.70061V15.6753H3.20061ZM12.6728 15.5816H3.10686V17.0816H12.6728V15.5816ZM12.5791 6.58267V15.6753H14.0791V6.58267H12.5791ZM12.6728 5.17642H10.6744V6.67642H12.6728V5.17642ZM10.7682 5.27017V3.27148H9.26817V5.27017H10.7682ZM10.6744 5.17642C10.7262 5.17642 10.7682 5.21839 10.7682 5.27017H9.26817C9.26817 6.04682 9.89777 6.67642 10.6744 6.67642V5.17642ZM14.0791 6.58267C14.0791 5.80602 13.4495 5.17642 12.6728 5.17642V6.67642C12.6211 6.67642 12.5791 6.63445 12.5791 6.58267H14.0791ZM12.6728 17.0816C13.4495 17.0816 14.0791 16.452 14.0791 15.6753H12.5791C12.5791 15.6236 12.6211 15.5816 12.6728 15.5816V17.0816ZM1.70061 15.6753C1.70061 16.452 2.33021 17.0816 3.10686 17.0816V15.5816C3.15863 15.5816 3.20061 15.6236 3.20061 15.6753H1.70061ZM9.36192 3.36523C9.31014 3.36523 9.26817 3.32326 9.26817 3.27148H10.7682C10.7682 2.49483 10.1386 1.86523 9.36192 1.86523V3.36523ZM3.10686 1.86523C2.33021 1.86523 1.70061 2.49483 1.70061 3.27148H3.20061C3.20061 3.32326 3.15863 3.36523 3.10686 3.36523V1.86523Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78175 2.61523L13.2503 6.08374",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12436 9.59277L7.21392 11.6823L10 8.89625",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39963 14.3786H10.9762L15.1148 10.24C15.3238 10.031 15.4413 9.7474 15.4413 9.45173C15.4413 9.15606 15.3238 8.87251 15.1148 8.66344C14.9057 8.45437 14.6221 8.33691 14.3265 8.33691C14.0308 8.33691 13.7473 8.45437 13.5382 8.66344L9.39963 12.802V14.3786Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchPractice);
export default __webpack_public_path__ + "static/media/icon_search_practice.9d1f8a9a040b0cfc2f79076c022c8272.svg";
export { ForwardRef as ReactComponent };